/**
 * @file The Component contains the whole Configuration information for user to review their choices
 * @author Haonan Yu(haoyu@microStrategy.com)
 */
import React from 'react';
import { Button, Row, Col, Icon, Form } from 'antd';

//data & funcs
import { generateLinuxFile } from '../../../../FileGenerator/FileGenerator';
import { generateSummary, triggerLambda } from '../../../../Utils/utils';
import {
    summaryStructure,
    state2PrefixMap,
    state2CommentMap,
} from '../../../../Utils/LinuxDataLoader';
import {
    M2021,
    M11_3_4,
    M11_3_4_1,
    M11_3_5,
    M11_3_5_1,
    M11_3_5_2,
    M11_3_6,
    M11_3_7,
    M11_3_8,
    M11_3_9,
    M11_3_10,
    M11_3_11,
    M11_3_12,
    M11_4_03,
    M11_4_06,
    M11_4_09,
    M11_4_12,
    M11_5_03,
} from '../../../../Utils/Constants';
//components
import Navigation from '../../../Navigation/Navigation';
//css
import 'antd/dist/antd.css';
import '../../../../Utils/CommonCss.css';

class Summary extends React.Component {
    backStep = () => {
        this.props.backStep();
    };

    /**
     * To generate the Option.txt and download it locally
     */
    downloadTxtFile = () => {
        const element = document.createElement('a');
        let res = generateLinuxFile(
            this.props,
            state2PrefixMap,
            state2CommentMap
        );

        let fileName;
        switch (this.props.useVersion) {
            case M2021:
                fileName = 'options_m2021.txt';
                break;
            case M11_3_4:
                fileName = 'options_m11_3_4.txt';
                break;
            case M11_3_4_1:
                fileName = 'options_m11_3_4_1.txt';
                break;
            case M11_3_5:
                fileName = 'options_m11_3_5.txt';
                break;
            case M11_3_5_1:
                fileName = 'options_m11_3_5_1.txt';
                break;
            case M11_3_5_2:
                fileName = 'options_m11_3_5_2.txt';
                break;
            case M11_3_6:
                fileName = 'options_m11_3_6.txt';
                break;
            case M11_3_7:
                fileName = 'options_m11_3_7.txt';
                break;
            case M11_3_8:
                fileName = 'options_m11_3_8.txt';
                break;
            case M11_3_9:
                fileName = 'options_m11_3_9.txt';
                break;
            case M11_3_10:
                fileName = 'options_m11_3_10.txt';
                break;
            case M11_3_11:
                fileName = 'options_m11_3_11.txt';
                break;
            case M11_3_12:
                fileName = 'options_m11_3_12.txt';                
                break;
            case M11_4_03:
                fileName = 'options_m11_4_03.txt';                
                break;
            case M11_4_06:
                fileName = 'options_m11_4_06.txt';                
                break;
            case M11_4_09:
                fileName = 'options_m11_4_09.txt';                
                break;
            case M11_4_12:
                fileName = 'options_m11_4_12.txt';                
                break;
            case M11_5_03:
                fileName = 'options_m11_5_03.txt';                
                break;
            default:
        }

        let file = new File([res], fileName, {
            type: 'text/plain',
        });

        element.href = URL.createObjectURL(file);
        element.download = file.name;
        document.body.appendChild(element); // Required for this to work in FireFox
        element.click();

        let info = {
            fileName: file.name,
            companyName: this.props.getOriginState('userRegistrationCompany'),
            os: this.props.useOs,
            mode: this.props.useMode,
            version: this.props.useVersion,
        };

        triggerLambda(
            info,
            function (response) {
                console.log('Success!');
            },
            function (error) {
                console.error(error);
            }
        );
    };

    render() {
        return (
            <Form className="form">
                <Row type="flex" align="top">
                    <Col
                        span={4}
                        className={['colNav', 'linSummaryNavHeight'].join(' ')}
                    >
                        <p className="headlineTop">Steps</p>
                        <Navigation
                            setOriginState={this.props.setOriginState}
                            getOriginState={this.props.getOriginState}
                            steps={this.props.steps}
                            deepestStep={this.props.deepestStep}
                            useOs={this.props.useOs}
                        />
                    </Col>

                    <Col span={18} className="colContent">
                        <p className="headlineTop">Summary</p>
                        <div className="summaryContainer">
                            {generateSummary(summaryStructure, this.props)}
                        </div>
                    </Col>
                </Row>
                <div className="buttonBar">
                    <div className="description">
                        You are creating a configuration file for
                        <img
                            src={require('../../../../assets/Icons/Linux.png')}
                            alt="Operating System"
                        />
                    </div>
                    <div className="buttons">
                        <Button
                            className="buttonBack"
                            type="default"
                            onClick={this.backStep}
                        >
                            Back
                        </Button>
                        <Button
                            className="buttonNext"
                            type="primary"
                            onClick={this.downloadTxtFile}
                        >
                            <Icon type="vertical-align-bottom" />
                            Download File
                        </Button>
                    </div>
                </div>
            </Form>
        );
    }
}

export default Summary;
